<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Mechanical Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Faculty'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="4"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Faculty</div>
          <faculty-card class="mb-5"
                        v-for="(faculty, index) in facultyList"
                        :key="index"
                        :faculty="faculty"
                        :dir="dirName"></faculty-card>

        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mechanical/Sidebar";
import FacultyCard from "@/components/FacultyCard";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Faculty",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    FacultyCard,
    KeyRecruiters
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      dirName: 'mechanical',
      facultyList: [
        {
          'name': ' Prof T.V.Gujrathi',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': 'HOD, Assistant Professor',
          'qualification': 'ME (Design), BE (Mechanical) ',
          'experience': '7.5',
          'specialization': 'Design Engineering',
          'contact': '9028186643',
          'email': 'tushargujrathi30592@gmail.com'
        },
        {
          'name': 'Prof A.P.Ghodake',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Design), BE (Mechanical) ',
          'experience': '11.6',
          'specialization': 'Design Engineering',
          'contact': '7387951990',
          'email': 'ghodakearvind15@gmail.com'
        },
        {
          'name': 'Prof M.S.Deshmukh',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Design), BE (Mechanical) ',
          'experience': '8.5',
          'specialization': 'Design Engineering',
          'contact': '8459272718',
          'email': 'maheshsdeshmukh11@gmail.com'
        },
        {
          'name': 'Prof V.D.Londhe',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Design), BE (Mechanical)',
          'experience': '13.5',
          'specialization': 'Design Engineering',
          'contact': '9890991426',
          'email': 'vikrant3700@gmail.com'
        },
        {
          'name': 'Prof D.P.Kshirsagar',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Design), BE (Mechanical), PhD*',
          'experience': '8.5',
          'specialization': 'Design Engineering',
          'contact': '9561433108',
          'email': 'dattatrayakshirsagar07@gmail.com'
        },
        {
          'name': 'Prof B.S.Dange',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'M Tech. (Thermal), BE (Mechanical)',
          'experience': '9.5',
          'specialization': 'Thermal Engineering',
          'contact': '7028822593',
          'email': 'bharatdange@gmail.com'
        },
        {
          'name': 'Prof H.R.Aher',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Design), BE (Mechanical)',
          'experience': '11.5',
          'specialization': 'Design Engineering',
          'contact': '9960789717',
          'email': 'harshal.aher5@gmail.com'
        },
        {
          'name': 'Prof S.S.Aher',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Design), BE (Mechanical), PhD*',
          'experience': '13',
          'specialization': 'Design Engineering',
          'contact': '9552650839',
          'email': 'sandeepsaher06@gmail.com'
        },
        {
          'name': 'Prof P.S.Baravkar',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Design), BE (Mechanical), PhD*',
          'experience': '11.5',
          'specialization': 'Design Engineering',
          'contact': '8149386507',
          'email': 'pavanbaravkar49@gmail.com'
        },
        {
          'name': 'Prof V.R.Thakare',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'M.Tech, B.E Mechanical, Diploma in Automobile ',
          'experience': '12',
          'specialization': 'Machine Design',
          'contact': '9730368756',
          'email': 'vishalthakare88@gmail.com'
        },
        {
          'name': 'Prof R.H. Pardeshi',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'M.E (Mechanical), BE (Mechanical)',
          'experience': '13',
          'specialization': 'Mechanical Engg',
          'contact': '9922360989',
          'email': 'rahulp2108@gmail.com'
        },
        {
          'name': 'Prof.G.J.Pathak',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'M.Tech(Thermal) B.E Mechanical, Diploma in mechanical',
          'experience': '16',
          'specialization': 'Thermal Engineering',
          'contact': '9284076226',
          'email': 'ggauravpathak@yahoo.co.in'
        },
        {
          'name': 'Prof.H.P. Ghongade',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'M.TECH(Machine design),BE(Mechanical),PhD*',
          'experience': '10',
          'specialization': 'Machine Design',
          'contact': '9022487352',
          'email': 'ghongade@gmail.com'
        },
        {
          'name': 'Prof. A.R.Nikam',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Machine Design), BE(Mechanical)',
          'experience': '15',
          'specialization': 'Machine Design',
          'contact': '8275053449',
          'email': 'amolnik79@gmail.com'
        },
        {
          'name': 'Prof N .G.Chaudhuri ',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': ' Assistant Professor',
          'qualification': 'ME (Machine Design), BE(Mechanical)',
          'experience': '2.5',
          'specialization': 'Design Engineering',
          'contact': '7507872767',
          'email': 'nileshchaudhuri600@gmail.com'
        },
        {
          'name': 'Prof S.B.Thore',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': 'Teaching Assistant',
          'qualification': 'BE(Mechanical),Diploma(Mechanical),ME*',
          'experience': '0.3',
          'specialization': 'Mechanical',
          'contact': '9370100528',
          'email': 'saiprasadthore@gmail.com'
        },
        {
          'name': 'Mr. V.U.Sabale',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': 'Lab Assistant',
          'qualification': ' MBA , B.E(Mechanicl)',
          'experience': '6',
          'specialization': 'Mechanical',
          'contact': '9049829719',
          'email': 'vikassable93@gmail.com'
        },
        {
          'name': 'Mr. D.K. Satalkar',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': 'Workshop Trainer',
          'qualification': 'ITI Sheet Metal',
          'experience': '17',
          'specialization': 'Sheet Metal',
          'contact': '7875500695',
          'email': 'satalkardk@gmail.com'
        },
        {
          'name': 'Mr. Y.K. Chaudhari',
          'cv': 'test.pdf',
          'image': 'employee_placeholder_male',
          'designation': 'Workshop Trainer',
          'qualification': 'ITI Turner',
          'experience': '6',
          'specialization': 'Turner',
          'contact': '8788882635',
          'email': 'chaudhariyogeshk333@gmail.com'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
